import React from "react"
class HousekeepingStatusBoardLog extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <tr key={segment.id}>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    );
  }

};
export default HousekeepingStatusBoardLog
